// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3EeAw","legacyBtn":"MutateMid_legacyBtn__3Ejx4"};